module.exports = __webpack_public_path__ + "img/streams-icon.549f6fe9.svg";